/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountManagerSearchResult} from '../models/AccountManagerSearchResult';
import type {Error} from '../models/Error';

export interface RunAccountManagerSearch$Request {
    name?: string;
}

export interface RunAccountManagerSearch$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const runAccountManagerSearchRequest = createAction<PayloadData<void, RunAccountManagerSearch$Request>>('RUN_ACCOUNT_MANAGER_SEARCH__RUN_ACCOUNT_MANAGER_SEARCH__REQUEST');
export const runAccountManagerSearchSuccess = createAction<PayloadData<Array<AccountManagerSearchResult>, RunAccountManagerSearch$Request>>('RUN_ACCOUNT_MANAGER_SEARCH__RUN_ACCOUNT_MANAGER_SEARCH__SUCCESS');
export const runAccountManagerSearchFailure = createAction<PayloadData<Error, RunAccountManagerSearch$Request, true>>('RUN_ACCOUNT_MANAGER_SEARCH__RUN_ACCOUNT_MANAGER_SEARCH__FAILURE');

export const runAccountManagerSearchActions = [
    runAccountManagerSearchRequest,
    runAccountManagerSearchSuccess,
    runAccountManagerSearchFailure
] as const;

/**
 * @param {string} [meta.name] Account manager first/last name or email
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const runAccountManagerSearch = (meta: RunAccountManagerSearch$Request, config?: RunAccountManagerSearch$Config) => {
    const TRANSPORT_GET_PARAMS = {
        name: meta.name,
    };
    return {
        CALL_API: {
            types: runAccountManagerSearchActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/account-managers/search`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

